import { useEffect, useState } from "react";
import { adapter } from "@/services/db";

// Realtime-ish subscription to a collection via the backend admin proxy
// (light polling). `opts` may include { limit, order_by, desc }.
export function useCollection(collectionName, opts) {
  const [rows, setRows] = useState([]);
  const key = JSON.stringify(opts || {});
  useEffect(() => {
    const unsub = adapter.subscribe(collectionName, setRows, opts || {});
    return () => unsub && unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionName, key]);
  return rows;
}
